import { useLabelVersion } from '../../../features/labels/LabelsProvider';
import { labelId } from '../../../features/labels/labels';
﻿// import React, { useState, useMemo } from 'react';
import './ProductionReport.css'; // los estilos que vienen abajo

// const MenuRegion = ({data}) => {
//   const [viewMode, setViewMode] = useState('week'); // 'day' | 'week' | 'month'

//   // 1) Obtengo lista de todas las fechas crudas
//   const allDates = useMemo(() => {
//     const fechas = Object.values(data.analytic_data)
//       .flatMap(areaObj =>
//         Object.values(areaObj)
//           .flatMap(center =>
//             Object.keys(center.values_summary)
//               .map(str => {
//                 const [d, m, y] = str.split('/');
//                 return new Date(+y, +m - 1, +d);
//               })
//           )
//       );
//     // quito duplicados (comparing time value) y ordeno
//     const uniq = Array.from(new Map(
//       fechas.map(d => [d.getTime(), d])
//     ).values());
//     return uniq.sort((a, b) => a - b);
//   }, [data]);

//   // 2) Funciones de formato segÃºn modo
//   const formatPeriod = date => {
//     if (viewMode === 'day') {
//       return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
//     }
//     if (viewMode === 'week') {
//       // use ISO week
//       const week = getWeekNumber(date);
//       return `Semana ${week}`;
//     }
//     // month
//     return date.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
//   };

//   // 3) Encabezados (periodos Ãºnicos con orden original)
//   const periods = useMemo(() => {
//     return Array.from(new Set(allDates.map(d => formatPeriod(d))));
//   }, [allDates, viewMode]);

//   return (
//  <>
//       <div className="view-selector">
//         <label>
//           Ver por:&nbsp;
//           <select value={viewMode} onChange={e => setViewMode(e.target.value)}>
//             <option value="day">DÃ­a</option>
//             <option value="week">Semana</option>
//             <option value="month">Mes</option>
//           </select>
//         </label>
//       </div>

//       <table className="production-table">
//         <thead>
//           <tr>
//             <th rowSpan="2">Ãrea</th>
//             <th rowSpan="2">Centro</th>
//             <th colSpan={periods.length}>SFR CORREGIDO {viewMode === 'week' && '%'} </th>
//             <th colSpan={periods.length}>{metricNames.fasts_count}</th>
//             <th colSpan={periods.length}>Alarmas por raciones</th>
//           </tr>
//           <tr>
//             {periods.map(p => (
//               <th key={p}>{p}</th>
//             ))}
//             {periods.map(p => (
//               <th key={'f-'+p}>{p}</th>
//             ))}
//             {periods.map(p => (
//               <th key={'a-'+p}>{p}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {Object.entries(data.analytic_data).map(([areaName, centers]) => {
//             const centerNames = Object.keys(centers);
//             return centerNames.map((centerName, idx) => {
//               const summary = centers[centerName].values_summary;
//               return (
//                 <tr key={areaName + '_' + centerName}>
//                   {idx === 0 && (
//                     <td className="area-cell" rowSpan={centerNames.length}>
//                       {areaName}
//                     </td>
//                   )}
//                   <td>{centerName}</td>

//                   {/* SFR */}
//                   {periods.map((period, i) => {
//                     // buscamos en summary la fecha que, al formatear, coincida
//                     const dateObj = allDates.find(d => formatPeriod(d) === period);
//                     const val = dateObj
//                       ? summary[formatPeriod(dateObj)]?.sfr_value ?? '-'
//                       : '-';
//                     return <td key={`sfr-${centerName}-${i}`}>{val}</td>;
//                   })}

//                   {/* DÃ­as de ayuno */}
//                   {periods.map((period, i) => {
//                     const dateObj = allDates.find(d => formatPeriod(d) === period);
//                     const val = dateObj
//                       ? summary[formatPeriod(dateObj)]?.fasts_count ?? '-'
//                       : '-';
//                     return <td key={`fasts-${centerName}-${i}`}>{val}</td>;
//                   })}

//                   {/* Alarmas */}
//                   {periods.map((period, i) => {
//                     const dateObj = allDates.find(d => formatPeriod(d) === period);
//                     const val = dateObj
//                       ? summary[formatPeriod(dateObj)]?.alarms_count ?? '-'
//                       : '-';
//                     return <td key={`alarms-${centerName}-${i}`}>{val}</td>;
//                   })}
//                 </tr>
//               );
//             });
//           })}
//         </tbody>
//       </table>
//     </>
//   )
// }

// export default MenuRegion;
import React, { useState, useMemo, useEffect } from 'react';
import { parse, format, getISOWeek, subDays, subWeeks, subMonths } from 'date-fns';


const defaultThresholds = {
  sfr_value: [
    { min: 0, max: 50, color: '#9B2020' },
    { min: 50, max: 100, color: '#9E9E1F' },
    { min: 100, max: Infinity, color: '#3F943F' }
  ],
  alarms_by_ton: [
    { min: 0, max: 1, color: '#3F943F' },
    { min: 1, max: 3, color: '#9E9E1F' },
    { min: 3, max: Infinity, color: '#9B2020' }
  ],
  fasts_count: [
    { min: 0, max: 2, color: '#3F943F' },
    { min: 2, max: 5, color: '#9E9E1F' },
    { min: 5, max: Infinity, color: '#9B2020' }
  ]
};


/**
 * DataDashboard
 * Muestra mÃ©tricas sfr_value, alarms_by_ton y fasts_count
 * Permite ver los Ãºltimos 7 dÃ­as, Ãºltimas 4 semanas o Ãºltimos 4 meses
 * y seleccionar bloques completos de perÃ­odo.
 */
const DataDashboard = ({ data: inputData, translate }) => {
  useLabelVersion();
  const t = (key, fallback) => {
    const value = typeof translate === 'function' ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  const [period, setPeriod] = useState('day');
  const [thresholds, setThresholds] = useState(defaultThresholds);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const sourceData = inputData?.analytic_data ? inputData : sampleData;
  const analytic_data = sourceData?.analytic_data ?? {};
  // NÃºmero de periodos a mostrar segÃºn tipo
  const range = period === 'day' ? 7 : 4;

  // Generar etiquetas de los Ãºltimos periodos continuos
  const globalLabels = useMemo(() => {
    // Encontrar fecha mÃ¡xima en los datos
    let maxDate = null;
    Object.values(analytic_data).forEach(centers =>
      Object.values(centers).forEach(cData =>
        Object.keys(cData.values_summary).forEach(dateStr => {
          const d = parse(dateStr, 'dd/MM/yyyy', new Date());
          if (!maxDate || d > maxDate) maxDate = d;
        })
      )
    );
    if (!maxDate) maxDate = new Date();

    const labels = [];
    // Ãšltimos 7 dÃ­as
    if (period === 'day') {
      for (let i = range - 1; i >= 0; i--) {
        const d = subDays(maxDate, i);
        labels.push(format(d, 'dd/MM/yyyy'));
      }
    }
    // Ãšltimas 4 semanas
    else if (period === 'week') {
      for (let i = range - 1; i >= 0; i--) {
        const d = subWeeks(maxDate, i);
        // labels.push(String(getISOWeek(d)));
        labels.push(`${getISOWeek(d)}/${format(d, 'yyyy')}`);
      }
    }
    // Ãšltimos 4 meses
    else {
      for (let i = range - 1; i >= 0; i--) {
        const d = subMonths(maxDate, i);
        labels.push(format(d, 'MMM yyyy'));
      }
    }
    return labels;
  }, [analytic_data, period]);

  // Inicializar selecciÃ³n con todos los bloques
  useEffect(() => {
    setSelectedLabels(globalLabels);
  }, [globalLabels]);

  // Umbrales de color
  // const thresholds = {
  //   sfr_value: [
  //     { min: 0, max: 50, color: '#9B2020' },
  //     { min: 50, max: 100, color: '#9E9E1F' },
  //     { min: 100, max: Infinity, color: '#3F943F' }
  //   ],
  //   alarms_by_ton: [
  //     { min: 0, max: 1, color: '#3F943F' },
  //     { min: 1, max: 3, color: '#9E9E1F' },
  //     { min: 3, max: Infinity, color: '#9B2020' }
  //   ],
  //   fasts_count: [
  //     { min: 0, max: 2, color: '#3F943F' },
  //     { min: 2, max: 5, color: '#9E9E1F' },
  //     { min: 5, max: Infinity, color: '#9B2020' }
  //   ]
  // };

  const getColor = (metric, value) => {
    const threshold = thresholds[metric]?.find(t => value >= t.min && value < t.max);
    return threshold ? threshold.color : '#37383A';
  };

  // Procesar datos y alinear con globalLabels
  const processed = useMemo(() => {
    const result = {};
    Object.entries(analytic_data).forEach(([areaKey, centers]) => {
      const areaName = areaKey.split('-')[1];
      result[areaName] = {};

      Object.entries(centers).forEach(([centerKey, cData]) => {
        const centerName = centerKey.split('-').pop();
        const dayMap = {}, weekMap = {}, monthMap = {};
        Object.entries(cData.values_summary).forEach(([dateStr, metrics]) => {
          const date = parse(dateStr, 'dd/MM/yyyy', new Date());
          const day = format(date, 'dd/MM/yyyy');
          dayMap[day] = metrics;

          const wk = `${getISOWeek(date)}/${format(date, 'yyyy')}`;
          weekMap[wk] = weekMap[wk] || { sum: {}, count: 0 };
          ['sfr_value', 'alarms_by_ton', 'fasts_count'].forEach(m => {
            weekMap[wk].sum[m] = (weekMap[wk].sum[m] || 0) + metrics[m];
          });
          weekMap[wk].count++;

          const mon = format(date, 'MMM yyyy');
          monthMap[mon] = monthMap[mon] || { sum: {}, count: 0 };
          ['sfr_value', 'alarms_by_ton', 'fasts_count'].forEach(m => {
            monthMap[mon].sum[m] = (monthMap[mon].sum[m] || 0) + metrics[m];
          });
          monthMap[mon].count++;
        });

        const metricsData = { areaKey, centerKey };
        ['sfr_value', 'alarms_by_ton', 'fasts_count'].forEach(metric => {
          const values = globalLabels.map(label => {
            let val = null;
            if (period === 'day') val = dayMap[label]?.[metric] ?? null;
            if (period === 'week') {
              const w = weekMap[label];
              if (w) val = metric === 'sfr_value' ? w.sum[metric] / w.count : w.sum[metric];
            }
            if (period === 'month') {
              const m = monthMap[label];
              if (m) val = metric === 'sfr_value' ? m.sum[metric] / m.count : m.sum[metric];
            }
            return val != null
              ? metric === 'sfr_value'
                ? parseFloat(val).toFixed(2)
                : val
              : null;
          });
          metricsData[metric] = { labels: globalLabels, values };
        });

        result[areaName][centerName] = metricsData;
      });
    });
    return result;
  }, [analytic_data, globalLabels, period]);

    // Function to update a specific threshold
  const handleThresholdChange = (metric, index, field, newVal) => {
    setThresholds(prev => {
      const updated = { ...prev };
      const metricArr = [...updated[metric]];
      metricArr[index] = { ...metricArr[index], [field]: newVal };
      updated[metric] = metricArr;
      return updated;
    });
  };

  const metricNames = {
    sfr_value: t('corrected_sfr', 'SFR Corregido [ % ]'),
    alarms_by_ton: t('alarms_per_ton', 'Alarmas por tonelada'),
    fasts_count: t('fasting_days', 'Dias de ayuno')
  };


  return (
    <div >
      {/* Controles de perÃ­odo y bloques */}
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', height:'2vh', overflowY:'auto' }}>
        <label style={{ color: '#c3c3c3', minWidth: '5vw' }}>{t('select_period', 'Ver por')}:</label>
        <select value={period} onChange={e => setPeriod(e.target.value)}>
          <option value='day'>{t('day', 'Dia')}</option>
          <option value='week'>{t('week', 'Semana')}</option>
          <option value='month'>{t('month', 'Mes')}</option>
        </select>
        <select
          multiple
          value={selectedLabels}
          onChange={e => {
            const opts = Array.from(e.target.selectedOptions).map(o => o.value);
            setSelectedLabels(opts);
          }}
          style={{ minWidth: '150px', height: '100px' }}
        >
          {globalLabels.map(label => (
            <option key={label} value={label}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {/* Tabla de mÃ©tricas */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '6vw repeat(3,1fr)',
          // fontWeight: 'bold',
          // padding: '0.5rem',
          // borderBottom: '0.01vw solid #c3c3c3'
        }}
      >
        <div style={{display:'flex', justifyContent:'center', alignContent:'center', alignItems:'center', backgroundColor:'rgba(0,0,0,0)', width:'6vw',height:'4vh',}}>{t('area_center', 'Area / Centro')}</div>
        <div style={{display:'flex', justifyContent:'center', alignContent:'center', alignItems:'center',height:'4vh', width:'29vw',marginLeft:'2.5vw',backgroundColor:'#28292B', borderRadius:'0.5vw', marginBottom:'1.5vh'}} >{metricNames.sfr_value}</div>
        <div style={{display:'flex', justifyContent:'center', alignContent:'center', alignItems:'center',height:'4vh', width:'29.08vw',marginLeft:'.98vw',backgroundColor:'#28292B', borderRadius:'0.5vw', marginBottom:'1.5vh'}}>{metricNames.alarms_by_ton}</div>
        <div style={{display:'flex', justifyContent:'center', alignContent:'center', alignItems:'center',height:'4vh', width:'29.04vw',marginLeft:'.38vw',backgroundColor:'#28292B', borderRadius:'0.5vw', marginBottom:'1.5vh'}}>{metricNames.fasts_count}</div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '8vw repeat(21,1fr)',
        }}
      >
        <div style={{  display:'flex', justifyContent:'center',alignContent:'center',alignItems:'center', height:'2vh', width:'5vw',  }}> </div>
        {Object.keys(metricNames).map((metric) =>(
          <div key={metric} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width:'30vw', gap:'1vw',  }}>
            {selectedLabels.map((label, idx) => (
                <div
                  key={`${metric}-${label}`}
                  style={{
                    // backgroundColor: '#28292b',
                    backgroundColor:idx % 2 === 0 ?'#28292b': '',
                    color: '#C3C3C3',
                    width:'3.3vw',
                    height:'2.5vh',
                    // padding:'0 1vw',
                    // border:'solid 0.01vw',
                    borderTopLeftRadius:'0.5vw',
                    borderTopRightRadius:'0.5vw',
                    display:'flex',
                    justifyContent:'center',
                    alignContent:'center',
                    alignItems:'center',
                    zIndex:'1',
                    fontSize:'0.5vw'
                  }}
                >
                  {label}
                </div>
            ))}
          </div>
        )
        )} 
      </div>
      <div style={{ height:'60vh', overflowY:'auto'}}>
        {Object.entries(processed).map(([area, centers]) => (
          <div key={area} style={{display:'flex', overflowY:'auto', borderTop:' solid 0.01vw #e84e0e'}}>
            <div
              style={{
                display: 'flex',
                justifyContent:'center',
                alignContent:'center',
                alignItems:'center',
                borderRight: '0.01vw solid #37383A',
                width:'2vw'
              }}
            >
              <div style={{  writingMode: 'vertical-rl',transform: 'rotate(180deg)'}}>{labelId(Object.values(centers)[0]?.areaKey, "ra", area)}</div>
            </div>
            <div style={{//borderBottom:'solid 0.01vw #c3c3c3'

            }}>
              {Object.entries(centers).map(([center, metricsData]) => (
                <div
                  key={center}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '6vw repeat(3,1fr)',

                  }}
                >
                  <div style={{  display:'flex', justifyContent:'center',alignContent:'center',alignItems:'center', height:'8vh', width:'5vw',  }}>{labelId(metricsData.centerKey, "rac", center)}</div>
                  
                  {['sfr_value', 'alarms_by_ton', 'fasts_count'].map(metric => (
                    <div
                      key={metric}
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width:'30vw', gap:'1vw', }}
                    >
                      {selectedLabels.map(label => {
                        const idx = metricsData[metric].labels.indexOf(label);
                        const val = idx >= 0 ? metricsData[metric].values[idx] : null;
                        return (
                          <div key={label} style={{ zIndex:'1',display:'flex', justifyContent:'center',alignContent:'center',alignItems:'center', flexDirection:'column' ,textAlign: 'center', backgroundColor:idx % 2 === 0 ?'#28292b': '', width:'3.3vw', height:'8vh', //border:'solid 0.01vw'
                          }}>
                            <div
                              style={{
                                display:'flex',
                                justifyContent:'center',
                                alignContent:'center',
                                alignItems:'center',
                                border: `0.1vw solid ${val != null ? getColor(metric, val) : '#37383A'}`,
                                borderRadius: '100%',
                                height:'2.5vw',
                                width:'2.5vw'
                              }}
                            >
                              <p style={{fontSize:'.6vw', color:'#c3c3c3', marginTop:'.1vh'}}>
                                {val != null ? val : '--'}
                              </p>
                            </div>
                            <div style={{ display:'flex',justifyContent:'center',alignContent:'center',alignItems:'center',backgroundColor:'#37383A', width:'3vw', height:'1.8vh', borderRadius:'2vw', marginTop:'-1.8vh', color:'#c3c3c3' }}>
                              {/* {label} */} --
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ))}
    
                <div style={{ height:'0.1vh', width:'96vw', backgroundColor:'#37383A', zIndex:'0'}}></div>

                </div>
              ))}
            </div>
            {/* <div style={{position:'absolute', height:'0.1vh', width:'96vw', backgroundColor:'#e84e0e', zIndex:'0'}}></div> */}

          </div>
        ))}
      </div>
      <div style={{position:'absolute', height:'0.1vh', width:'vw', backgroundColor:'#e84e0e', zIndex:'0'}}></div>

      <div style={{ marginTop: '1vh', padding: '.5vw', background: '#28292B', borderRadius: '0.5vw' }}>
        <h3 style={{ color: '#C3C3C3', marginBottom: '1rem' }}>{t('configure_color_thresholds', 'Configurar umbrales de color')}</h3>
        <div style={{display:'flex', gap:'5vw'}}>
          {Object.entries(thresholds).map(([metric, arr]) => (
            <div key={metric} style={{ marginBottom: '1rem' }}>
              <strong style={{ color: '#FFF' }}>{metricNames[metric] || metric}</strong>
              {arr.map((threshold, idx) => (
                <div key={idx} style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginTop: '0.5rem' }}>
                  <label style={{ color: '#C3C3C3' }}>{t('min', 'Min')}:</label>
                  <input
                    type="number"
                    value={threshold.min === Infinity ? '' : threshold.min}
                    onChange={e => handleThresholdChange(metric, idx, 'min', Number(e.target.value))}
                    style={{ width: '4rem', padding: '0.2rem' }}
                  />
                  <label style={{ color: '#C3C3C3' }}>{t('max', 'Max')}:</label>
                  <input
                    type="number"
                    value={threshold.max === Infinity ? '' : threshold.max}
                    onChange={e => handleThresholdChange(metric, idx, 'max', Number(e.target.value))}
                    style={{ width: '4rem', padding: '0.2rem' }}
                  />
                  <label style={{ color: '#C3C3C3' }}>{t('color', 'Color')}:</label>
                  <input
                    type="color"
                    value={threshold.color}
                    onChange={e => handleThresholdChange(metric, idx, 'color', e.target.value)}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataDashboard;


const sampleData ={
    "analytic_data": {
      "Loslagos-Chiloe": {
        "Loslagos-Chiloe-Quehui": {
          "values_summary": {
            "13/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 3159,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 108,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            }
          }
        }
      },
      "Loslagos-Puertomontt": {
        "Loslagos-Puertomontt-Enviro": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 9378,
              "fasts_count": 4,
              "perdidos_cout": 0,
              "sfr_value": 81,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "13/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 4618,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 108,
              "tasa_units": "kg/min",
              "visitas_cout": 1
            }
          }
        },
        "Loslagos-Puertomontt-Itg": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 12920,
              "fasts_count": 9,
              "perdidos_cout": 2,
              "sfr_value": 57.875,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "11/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 3159,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 108,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            }
          }
        },
        "Loslagos-Puertomontt-Nanoox": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 11720,
              "fasts_count": 8,
              "perdidos_cout": 2,
              "sfr_value": 59.25,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "12/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 0,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 0,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            }
          }
        }
      },
      "Loslagos-Puertovaras": {
        "Loslagos-Puertomontt-Enviro": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 9378,
              "fasts_count": 4,
              "perdidos_cout": 0,
              "sfr_value": 81,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "13/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 4618,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 108,
              "tasa_units": "kg/min",
              "visitas_cout": 1
            }
          }
        },
        "Loslagos-Puertomontt-Itg": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 12920,
              "fasts_count": 9,
              "perdidos_cout": 2,
              "sfr_value": 57.875,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "11/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 3159,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 108,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            }
          }
        },
        "Loslagos-Puertomontt-Nanoox": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 11720,
              "fasts_count": 8,
              "perdidos_cout": 2,
              "sfr_value": 59.25,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "12/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 0,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 0,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            }
          }
        }
      },
      "Loslagos-muermos": {
        "Loslagos-Puertomontt-Enviro": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 9378,
              "fasts_count": 4,
              "perdidos_cout": 0,
              "sfr_value": 81,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "13/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 4618,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 108,
              "tasa_units": "kg/min",
              "visitas_cout": 1
            }
          }
        },
        "Loslagos-Puertomontt-Itg": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 12920,
              "fasts_count": 9,
              "perdidos_cout": 2,
              "sfr_value": 57.875,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "11/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 3159,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 108,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            }
          }
        },
        "Loslagos-Puertomontt-Nanoox": {
          "values_summary": {
            "10/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 11720,
              "fasts_count": 8,
              "perdidos_cout": 2,
              "sfr_value": 59.25,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            },
            "12/05/2025": {
              "alarms_by_ton": 0,
              "alarms_count": 0,
              "alarms_threshold": 3,
              "delivered_food": 0,
              "fasts_count": 1,
              "perdidos_cout": 0,
              "sfr_value": 0,
              "tasa_units": "kg/min",
              "visitas_cout": 0
            }
          }
        }
      }
    },
    "name": "Loslagos"
  }

